export default class Finding {
  constructor(finding = {}) {
    this.id = finding.id || null
    this.output = finding.output || null
    this.poc = finding.poc || {}
    this.findable = finding.findable || {}
    this.findable_type = finding.findable_type || null
    this.vulnerable_type = finding.vulnerable_type || null
    this.vulnerable = finding.vulnerable || {}
  }

  static mutations() {
    return {
      setFinding: (state, finding) => state.finding = new Finding(finding)
    }
  }
}